import {
  CLEAN_APPOINTMENTS,
  GET_APPOINTED_CARRIERS,
  GET_CARRIERS,
  SET_CARRIERS_ARRAY,
  SET_STATEMENTS_CARRIERS_ARRAY,
  GET_REQUESTED_APPOINTMENTS,
  IS_SENDING_REQUEST_APPOINTMENTS,
  IS_UPDATING_REQUEST_APPOINTMENTS,
  GET_STATEMENT_PERIODS,
  SET_REQUESTED_CARRIER_NAME,
  SET_IS_NEO_SUBMISSION_MODAL_OPEN,
  UPDATE_LOADING_APPOINTMENTS_DATA,
  SET_ATTACHMENTS
} from 'constants/types';

const INITIAL_STATE = {
  carriers: {
    Marketplace: [],
    'Off-Market Health': [],
    Medicare: [],
    Life: [],
    Group: []
  },
  carriersArray: [],
  attachments: [],
  satementsCarriersArray: [],
  requestedAppointments: [],
  requestedAppointmentsByCarrier: {},
  actionableAppointments: [],
  appointedCarriers: {
    Marketplace: [],
    'Off-Market Health': [],
    Medicare: [],
    Life: [],
    Group: []
  },
  isSendingRequestAppointments: false,
  isUpdatingRequestAppointments: false,
  requestedCarrierName: '',
  isNeoSubmissionModalOpen: false,
  statementPeriods: [],
  isLoadingAppointmentsData: false
};

function appointmentsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_CARRIERS:
      return { ...state, carriers: action.payload };
    case SET_CARRIERS_ARRAY:
      return { ...state, carriersArray: action.payload };
    case SET_STATEMENTS_CARRIERS_ARRAY:
      return { ...state, satementsCarriersArray: action.payload };
    case GET_REQUESTED_APPOINTMENTS:
      return {
        ...state,
        requestedAppointments: action.payload.requestedAppointments,
        actionableAppointments: action.payload.actionableAppointments,
        requestedAppointmentsByCarrier:
          action.payload.requestedAppointmentsByCarrier
      };
    case GET_APPOINTED_CARRIERS:
      return { ...state, appointedCarriers: action.payload };
    case CLEAN_APPOINTMENTS:
      return INITIAL_STATE;
    case IS_SENDING_REQUEST_APPOINTMENTS:
      return { ...state, isSendingRequestAppointments: action.payload };
    case IS_UPDATING_REQUEST_APPOINTMENTS:
      return { ...state, isUpdatingRequestAppointments: action.payload };
    case GET_STATEMENT_PERIODS:
      return { ...state, statementPeriods: action.payload };
    case SET_REQUESTED_CARRIER_NAME:
      return { ...state, requestedCarrierName: action.payload };
    case SET_IS_NEO_SUBMISSION_MODAL_OPEN:
      return { ...state, isNeoSubmissionModalOpen: action.payload };
    case UPDATE_LOADING_APPOINTMENTS_DATA:
      return { ...state, isLoadingAppointmentsData: action.payload };
    case SET_ATTACHMENTS:
      return { ...state, attachments: action.payload };
    default:
      return state;
  }
}

export default appointmentsReducer;
